export const getClientLocation = () => {
  return new Promise((resolve, reject) => {
    if (typeof window === "undefined") {
      resolve({ ipAddress: "unknown", country: "India", city: "Gurugram" });
      return;
    }

    // Get IP
    fetch("https://api.ipify.org?format=json")
      .then((res) => res.json())
      .then((ipData) => {
        const ipAddress = ipData.ip;

        // Get location from IP
        fetch(`https://ipapi.co/${ipAddress}/json/`)
          .then((res) => res.json())
          .then((locationData) => {
            resolve({
              ipAddress,
              country: locationData.country_code || "India",
              city: locationData.city || "Gurugram",
            });
          })
          .catch(() => {
            // Fallback to geolocation
            if (navigator.geolocation) {
              navigator.geolocation.getCurrentPosition(
                (position) => {
                  const { latitude, longitude } = position.coords;
                  // Reverse geocode
                  fetch(
                    `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`,
                  )
                    .then((res) => res.json())
                    .then((geoData) => {
                      resolve({
                        ipAddress,
                        country: geoData.countryCode || "India",
                        city: geoData.city || "Gurugram",
                      });
                    })
                    .catch(() => {
                      resolve({
                        ipAddress,
                        country: "India",
                        city: "Gurugram",
                      });
                    });
                },
                () => {
                  resolve({ ipAddress, country: "India", city: "Gurugram" });
                },
              );
            } else {
              resolve({ ipAddress, country: "India", city: "Gurugram" });
            }
          });
      })
      .catch(() => {
        resolve({ ipAddress: "unknown", country: "India", city: "Gurugram" });
      });
  });
};
